<template>
	<div>
		<template v-if="withText">
			<a
				href="#"
				class="link link--grow link--withicon"
				:class="{ 'link--active': isInWishlist }"
				@click.prevent="$store.toggleWishlistItemByIdAction(entryId)">
			
				<span class="link__text">{{ isInWishlist?'Remove from':'Add to' }} wishlist</span>
				
				<span class="link__icon">
					<span class="icon icon-splotch-2 link__splotch">
						<svg><use href="#icon-splotch-2" /></svg>
					</span>
					
					<span class="icon icon-heart link__symbol">
						<svg><use href="#icon-heart" /></svg>
					</span>
				</span>
			</a>
		</template>
		
		<template v-else>
			<span
				class="icon icon-heart wishlist__icon"
				@click.prevent="$store.toggleWishlistItemByIdAction(entryId)"
				:class="{ 'wishlist__icon--active': isInWishlist }">
				
				<svg><use href="#icon-heart" /></svg>
			</span>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			state: this.$store.state,
		}
	},
	props: ["entryId", "withText"],
	computed: {
		isInWishlist: function() {
			for (var item of this.state.wishlist) {
				if (item == this.entryId) {
					return true
				}
			}
			return false
		},
	},
}
</script>
